"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalServiceErrors = void 0;
var InternalServiceErrors;
(function (InternalServiceErrors) {
    InternalServiceErrors["USER_TOKEN_NOT_FOUND_IN_DATABASE"] = "USER_TOKEN_NOT_FOUND_IN_DATABASE";
    InternalServiceErrors["GET_EMPTY_RESPONSE_FROM_FACEBOOK_API"] = "GET_EMPTY_RESPONSE_FROM_FACEBOOK_API";
})(InternalServiceErrors = exports.InternalServiceErrors || (exports.InternalServiceErrors = {}));
//# sourceMappingURL=internalServiceErrors.enum.js.map